export const ff_placement_ui_clientconfirmation_sidemenu = 'ff_placement_ui_clientconfirmation_sidemenu';
export const ff_pricing_ui_pricingworkdesk = 'ff_pricing_ui_pricingworkdesk';
export const ff_placement_ui_templates_sidemenu = 'ff_placement_ui_templates_sidemenu';
export const ff_placement_ui_candidatecontracts_sidemenu = 'ff_placement_ui_candidatecontracts_sidemenu';
export const ff_shared_ui_auto_task_management_sidebar = 'ff_shared_ui_auto_task_management_sidebar';
export const ff_order_margintool = 'ff_order_margintool';